import { useCallback, useEffect, useState } from "react";
import { getRedeemCodeEndpoint, generateEndpointsByID } from "../../../api/types/endpoints";
import { OptInStatus } from "../../../api/types/enums";
import { useActionReducer } from "../../../../../context/ActionProvider";
import { usePageMetadata } from "../../../../../context/PageMetadata";
import { BH_ROUTES, ERROR_ROUTES } from "../../constants";
import { postAndRedirect } from "./postAndRedirect";
import { getValidInvitationCodeSearchParam } from "./getValidInvitationCodeSearchParam";
import { isInvitePage } from "./isInvitePage";
import { useAuthState } from "@riotgames/riotbar-react";
import { withURLParam } from "../../../../../blades/EmailSubscribe/utils/paramUtils";
import { INVITATION_CODE_PARAM, LOGIN_REDIRECT_URL_PARAM } from "./constants";
import { removeSearchParam } from "./removeSearchParams";
import { convertPageLocaleToPlayerLocale } from "../../utils";
const acceptedLocales = [
    "ar_AE",
    "cs_CZ",
    "de_DE",
    "el_GR",
    "en_AU",
    "en_GB",
    "en_PL",
    "en_SG",
    "en_US",
    "es_AR",
    "es_ES",
    "es_MX",
    "fr_FR",
    "hu_HU",
    "id_ID",
    "it_IT",
    "ja_JP",
    "ko_KR",
    "ms_MY",
    "pl_PL",
    "pt_BR",
    "ro_RO",
    "ru_RU",
    "th_TH",
    "tr_TR",
    "vi_VN",
    "zh_TW",
];
export const useBetaRegisterHandler = ({ campaignID }) => {
    const { isAuthenticated } = useAuthState();
    const { environment, locale } = usePageMetadata();
    const { dispatchAction } = useActionReducer();
    const [isLoading, setIsLoading] = useState(false);
    const invite = useCallback(async () => {
        const code = getValidInvitationCodeSearchParam();
        if (!code) {
            console.error("URL has been changed after last render");
            window.location.pathname = ERROR_ROUTES.INVALID_LINK;
            return;
        }
        removeSearchParam(INVITATION_CODE_PARAM);
        const { hostname } = window.location;
        return postAndRedirect({
            endpoint: getRedeemCodeEndpoint({ code, environment, hostname }),
        }, BH_ROUTES.INVITEE_SUCCESS, locale);
    }, [environment, locale]);
    const register = useCallback(() => {
        const { hostname } = window.location;
        const { REGISTER_ENDPOINT } = generateEndpointsByID({ campaignID, environment, hostname });
        const convertedPageLocale = convertPageLocaleToPlayerLocale(locale);
        const fallbackLocale = convertedPageLocale && acceptedLocales.includes(convertedPageLocale) ? convertedPageLocale : "en_US";
        return postAndRedirect({
            endpoint: REGISTER_ENDPOINT,
            body: {
                status: OptInStatus.OptedIn,
                locale: fallbackLocale,
            },
        }, BH_ROUTES.OPT_IN_SUCCESS, locale);
    }, [campaignID, environment, locale]);
    const handleAction = useCallback(async () => {
        if (isAuthenticated === true) {
            setIsLoading(true);
            return isInvitePage(locale) ? invite() : register();
        }
        else {
            setIsLoading(false);
            dispatchAction({
                type: "show_rso_modal",
                payload: { url: withURLParam(window.location.href, LOGIN_REDIRECT_URL_PARAM, "true").toString() },
            });
        }
    }, [dispatchAction, invite, isAuthenticated, locale, register]);
    useEffect(() => {
        if (isInvitePage(locale) && !getValidInvitationCodeSearchParam()) {
            window.location.pathname = ERROR_ROUTES.INVALID_LINK;
        }
    }, [locale]);
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has(LOGIN_REDIRECT_URL_PARAM) && isAuthenticated) {
            removeSearchParam(LOGIN_REDIRECT_URL_PARAM);
            handleAction();
        }
    }, [isAuthenticated, handleAction]);
    return { isLoading, handleButtonClick: handleAction };
};
//# sourceMappingURL=index.js.map